export default __webpack_public_path__ + "static/media/kz_fav.e42912e2.png";